export class WebCamConfiguration {
    constructor() {
        this.Guid = "";
        this.RtspUrl = "";
        this.UserName = null;
        this.Password = null;
    }
}
//# sourceMappingURL=IWebCamsService.js.map